import { LANDSCAPE_MEDIA_ASPECT_RATIO } from "../../EditLayout/mediaSpecs";
import { HeaderPhotoOrVideo } from "./HeaderPhotoOrVideo";
import { css } from "@emotion/react";
import { styleUtils } from "@minted/minted-components";
import React, { memo } from "react";

/**
 * Landscape media treatment — single photo constrained to the content
 * wrapper width (legacy l1 / Masthead image slot). Design theme does not
 * style this image; layout CSS only.
 */
const styles = {
  image: css`
    aspect-ratio: ${LANDSCAPE_MEDIA_ASPECT_RATIO};
    box-sizing: border-box;
    display: block;
    margin-bottom: ${styleUtils.rem(30)};
    object-fit: cover;
    width: 100%;
  `,
  // Mirrors fancyclothes Wrapper so landscape stays inset vs full-bleed.
  wrapper: css`
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    max-width: ${styleUtils.rem(1170)};
    padding-left: ${styleUtils.rem(15)};
    padding-right: ${styleUtils.rem(15)};
  `,
};

export type LandscapeMediaProps = {
  alt: string;
  headerSlotPosition: number;
  /** Which of photoURL or posterURL/videoURL to render. */
  mediaType: "photo" | "video";
  photoURL: string;
  /** Video poster thumbnail — video only. */
  posterURL?: string;
  /** Playable video src — video only. */
  videoURL?: string;
};

const LandscapeMedia = ({
  alt,
  headerSlotPosition,
  mediaType,
  photoURL,
  posterURL,
  videoURL,
}: LandscapeMediaProps) => (
  <div css={styles.wrapper}>
    <HeaderPhotoOrVideo
      alt={alt}
      headerSlotPosition={headerSlotPosition}
      imageCss={styles.image}
      mediaType={mediaType}
      photoURL={photoURL}
      posterURL={posterURL}
      videoURL={videoURL}
    />
  </div>
);

const MemoizedLandscapeMedia = memo(LandscapeMedia);

export { MemoizedLandscapeMedia as LandscapeMedia };
